import React, { createContext, useContext, useState, useEffect } from 'react';
import client from '../api/client';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const login = async (email, password) => {
        const { data } = await client.post('/auth/login', { email, password });
        localStorage.setItem('auth_token', data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        await client.post('/auth/logout');
        localStorage.removeItem('auth_token');
        setUser(null);
    };

    const refreshUser = async () => {
        const { data } = await client.get('/auth/me');
        setUser(data);
        return data;
    };

    useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            refreshUser()
                .catch(() => localStorage.removeItem('auth_token'))
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const hasPermission = (permissionSlug) => {
        if (!user) return false;
        if (user.role === 'ADMIN') return true;
        if (!user.permissions) return false;
        return user.permissions.some(p => p.slug === permissionSlug);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, refreshUser, isAuthenticated: !!user, loading, hasPermission }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);


